<nav class="navbar navbar-expand-lg navbar-light bg-light bg-black pb-0">
  <div
    class="d-flex px-5 pt-3"
    style="width: 100% !important"
    id="usercustomheader"
  >
    <div class="img-svg">
      <div
        class="w-161"
        style="
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: translate(-15px, -5px);
        "
        (click)="onClickLogo()"
        [innerHTML]="svgContent"
      ></div>
    </div>
    <div>
      <span class="notificationiconn">
        <button class="bell-mobile" mat-button [matMenuTriggerFor]="NotMenu">
          <mat-icon style="margin-bottom: 20px" class="belliconioss">
            <img src="../../../../assets/icon/bell.png" class="bell-png" />
          </mat-icon>
          <img
            class="dotttimg"
            src="../../../../assets/SVG/red dot.svg"
            *ngIf="unreadNotifications?.length > 0"
            alt=""
            style="position: absolute; top: 2px; right: -1px"
          />
          <!--  -->
        </button>
      </span>

      <button
        class="navbar-toggler m-1"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvas1"
        aria-controls="offcanvasExample"
      >
        <span
          class="navbar-toggler-icon"
          style="background-image: url(../../../../assets/SVG/Button.png)"
        ></span>
      </button>
    </div>
    <!-- lists in large screens -->
    <div
      class="collapse navbar-collapse"
      [ngClass]="{ show: !isCollapsed }"
      id="navbarText"
    >
      <ul class="navbar-nav mb-2 mb-lg-0 nav-br">
        <li class="nav-item text-center">
          <!-- Orders tab for user 4 -->
          <div
            style="cursor: pointer"
            mat-button
            [ngClass]="activeTabIndex === 0 ? 'new-link-active' : 'new-link'"
            (click)="toggleActive(0)"
            *ngIf="currentUser == 4"
            routerLink="/restaurant_dash/upcoming_orders"
          >
            <div [ngClass]="activeTabIndex === 0 ? 'tabs-rounded1' : ''"></div>
            <div [ngClass]="activeTabIndex === 0 ? 'tabs-rounded2' : ''"></div>
            Orders
          </div>

          <!-- Events tab for user 2 or 3 -->
          <div
            style="cursor: pointer"
            mat-button
            *ngIf="currentUser == 2 || currentUser == 3"
            [ngClass]="activeTabIndex === 1 ? 'new-link-active' : 'new-link'"
            (click)="toggleActive(1)"
          >
            <div [ngClass]="activeTabIndex === 1 ? 'tabs-rounded1' : ''"></div>
            <div [ngClass]="activeTabIndex === 1 ? 'tabs-rounded2' : ''"></div>
            Events
          </div>

          <!-- Manage Orders tab for user 2 or 3 -->
          <div
            style="cursor: pointer"
            mat-button
            *ngIf="currentUser == 2 || currentUser == 3"
            [ngClass]="activeTabIndex === 2 ? 'new-link-active' : 'new-link'"
            (click)="toggleActive(2)"
          >
            <div [ngClass]="activeTabIndex === 2 ? 'tabs-rounded1' : ''"></div>
            <div [ngClass]="activeTabIndex === 2 ? 'tabs-rounded2' : ''"></div>
            Manage Orders
          </div>
        </li>

        <div
          class="d-flex justify-content-center align-items-center g-2 px-0 py-2"
          style="gap: 10px; transform: translateY(-8px)"
        >
          <button
            mat-button
            routerLink="/cart"
            *ngIf="currentUser !== 4"
            class="cart-btn"
          >
            <img
              src="../../../../assets/icon/Buy.png"
              alt=""
              class="cart-icon"
            />
            <span style="font-size: 18px; font-weight: 600">Cart</span>
          </button>
          <!-- Notification Bell -->
          <li
            class="nav-item text-center notificationiconn"
            style="transform: translate(-15px, -5px)"
          >
            <button
              mat-button
              [matMenuTriggerFor]="NotMenu"
              id="bellIcon"
              style="position: relative"
            >
              <mat-icon style="height: unset" class="belliconioss">
                <img
                  src="../../../../assets/icon/bell.png"
                  class="bell-png"
                  style="width: 25px; height: 19"
                />
              </mat-icon>
              <img
                class="dotttimg"
                src="../../../../assets/SVG/red dot.svg"
                *ngIf="unreadNotifications?.length > 0"
                alt=""
                style="position: absolute; top: 0; right: 14px"
              />
            </button>

            <mat-menu
              #NotMenu="matMenu"
              class="clubnotification"
              panelClass="custom-menu-card"
            >
              <!-- Notifications List -->
              <div
                class="main-gr d-flex notify-item mt-2"
                *ngFor="let noti of NotificationsList; let index = index"
                (click)="readNotification(noti, index)"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
              >
                <div class="ellipse">
                  <img
                    class="notify-img notification-img"
                    [src]="
                      noti?.image
                        ? noti?.image
                        : '../../../../assets/image/Group 1261153964.svg'
                    "
                  />
                </div>
                <div class="lorem-text">
                  {{ noti?.heading }}
                  <div class="lotem-pera noti-text">{{ noti?.title }}</div>
                  <div class="hr-ago">{{ calculateTime(noti?.createdAt) }}</div>
                </div>
              </div>

              <!-- Empty Notification Message -->
              <div
                class="main-gr d-flex gap-4"
                [ngClass]="{
                  'notify-item': NotificationsList?.length > 0,
                  'no-notify-item': !NotificationsList?.length
                }"
                *ngIf="!NotificationsList?.length"
              >
                <div class="lorem-text">No Notification</div>
              </div>
            </mat-menu>
          </li>

          <!-- User Dropdown -->
          <li
            class="nav-item text-center"
            style="transform: translate(-5px, -5px)"
          >
            <div class="dropdown user-dropdown d-flex align-items-center gap-3">
              <div class="text-end text-white">
                <div style="font-weight: 600">{{ username }}</div>
                <div style="font-size: 12px">user</div>
              </div>
              <button
                class="btn btn-secondary dropdown-toggle d-flex justify-content-center align-items-center"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style="
                  width: 44px;
                  height: 44px;
                  font-size: 18px;
                  font-weight: 500;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 10px;
                "
              >
                {{ username[0] }}
              </button>
              <ul class="dropdown-menu user-dropdown-list">
                <div
                  class="dropdownnn"
                  [ngClass]="{
                    playerdropdown: currentUser == 3,
                    restodropdown: currentUser == 4
                  }"
                >
                  <li>
                    <button
                      mat-menu-item
                      (click)="editProfileClick()"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/user-edit -blue.png"
                        />
                      </mat-icon>
                      <span class="pop-siz">Edit Profile</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 2">
                    <button
                      mat-menu-item
                      routerLink="/manageEvents"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/calendar-stats.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Manage Events</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 2">
                    <button
                      mat-menu-item
                      (click)="manageTeamstClick()"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/steam.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Manage Teams</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 4">
                    <button
                      mat-menu-item
                      routerLink="/manageItems"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/landing-page/manage-items.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Manage Items</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 4">
                    <button
                      mat-menu-item
                      routerLink="/bankingDetails"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/landing-page/building-bank.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Bank Details</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 4">
                    <button
                      mat-menu-item
                      routerLink="/paymentDetails"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/report-money.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Payment Details</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 2">
                    <button
                      mat-menu-item
                      routerLink="/paymentReq"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/report-money.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Payment Requests</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 2 || currentUser == 3">
                    <button
                      mat-menu-item
                      routerLink="/manageOrders"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/layout-navbar-expand.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Manage Orders</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 2">
                    <button
                      mat-menu-item
                      routerLink="/playPromoCodes"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/layout-navbar-expand.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Promo Codes</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 3">
                    <button
                      mat-menu-item
                      routerLink="/favouriteOrders_players"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/heart.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Favorite Orders</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 2">
                    <button
                      mat-menu-item
                      routerLink="/favouriteOrders"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/heart.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Favorite Restaurants</span>
                    </button>
                  </li>

                  <li *ngIf="currentUser == 2 || currentUser == 3">
                    <button
                      mat-menu-item
                      (click)="cardDetails()"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/credit-card.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Card Details</span>
                    </button>
                  </li>

                  <li>
                    <button
                      mat-menu-item
                      (click)="changesPasswordClick()"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/lock (1).svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Change Password</span>
                    </button>
                  </li>

                  <li>
                    <button
                      mat-menu-item
                      (click)="contactusClick()"
                      routerLinkActive="active"
                    >
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/icon/mail (1).svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Contact Us</span>
                    </button>
                  </li>

                  <li>
                    <button mat-menu-item (click)="logoutClick()">
                      <mat-icon class="headerMenuIcon">
                        <img
                          height="24px"
                          width="24px"
                          src="../../../../assets/landing-page/logout.svg"
                        />
                      </mat-icon>
                      <span class="pop-siz">Logout</span>
                    </button>
                  </li>
                </div>
              </ul>
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>
</nav>

<!-- <button class="btn btn-primary" type="button" >
  Open
</button> -->

<div
  class="offcanvas offcanvas-end mob_sidenav"
  tabindex="-1"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  id="offcanvas1"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">&nbsp;</h5>
    <button
      id="closeSidnameMob"
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body">
    <button
      mat-button
      [ngClass]="{ active: isActive }"
      (click)="toggleActive(0)"
      *ngIf="currentUser == 4"
      routerLink="/restaurant_dash/upcoming_orders"
      data-bs-dismiss="offcanvas"
    >
      Orders</button
    ><br />

    <button
      mat-button
      [ngClass]="{ active: isActive }"
      (click)="toggleActive(currentUser)"
      *ngIf="currentUser == 2 || currentUser == 3"
      (click)="onEventButtonClick()"
      class="event"
      data-bs-dismiss="offcanvas"
    >
      Events
    </button>
    <br />
    <button
      mat-button
      routerLink="/cart"
      *ngIf="currentUser != 4"
      style="
        color: #fff;
        left: -4px;
        font-size: 15px;
        margin: 1rem 0;
        font-weight: 600;
      "
      data-bs-dismiss="offcanvas"
    >
      <mat-icon class="cartiosss" style="margin-bottom: 19px"
        ><img
          class="mobilecarticn"
          style="width: 25px"
          src="../../../../assets/icon/Buy.png" /></mat-icon
      >&nbsp;&nbsp; Cart
    </button>
    <div>
      <mat-menu #NotMenu="matMenu" panelClass="custom-menu-card">
        <!-- <button mat-menu-item>Not 1</button>
        <button mat-menu-item>Not 2</button> -->
        <div class="main-gr d-flex gap-4">
          <div class="ellipse">
            <img src="../../../../assets/icons/Ellipse23075.png" />
          </div>
          <div class="lorem-text">
            Lorem Ipsum
            <div class="lotem-pera">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
            <div class="hr-ago">2 hr ago</div>
          </div>
        </div>
      </mat-menu>
    </div>

    <div class="dropdown user-dropdown">
      <button
        class="btn btn-secondary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style="
          color: #fff;
          font-size: 15px;
          padding: 0;
          font-family: Lexend Deca;
          line-height: normal;
          background: transparent !important;
          border: none;
          box-shadow: none;
          font-weight: 600;
        "
      >
        {{ username }}
        <img
          class="arrowdownn"
          style=""
          src="../../../../assets/icons/Arrow-Down 2.png"
        /></button
      ><br />
      <ul class="dropdown-menu user-dropdown-list dropdown_mob_header">
        <li>
          <button
            mat-menu-item
            (click)="editProfileClick()"
            routerLinkActive="active"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/user-edit -blue.png" /></mat-icon
            ><span class="pop-siz">Edit Profile</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 2"
            routerLinkActive="active"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            routerLink="/manageEvents"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/calendar-stats.svg" /></mat-icon
            ><span class="pop-siz"> Manage Events</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 2"
            routerLinkActive="active"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            (click)="manageTeamstClick()"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/steam.svg" /></mat-icon
            ><span class="pop-siz">Manage Teams</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 4"
            routerLinkActive="active"
            routerLink="/manageItems"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/landing-page/manage-items.svg" /></mat-icon
            ><span class="pop-siz">Manage Items</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 4"
            routerLinkActive="active"
            routerLink="/bankingDetails"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/landing-page/building-bank.svg" /></mat-icon
            ><span class="pop-siz">Bank Details</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 4"
            routerLinkActive="active"
            routerLink="/paymentDetails"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/report-money.svg" /></mat-icon
            ><span class="pop-siz">Payment Details </span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 2"
            routerLinkActive="active"
            routerLink="/paymentReq"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/report-money.svg" /></mat-icon
            ><span class="pop-siz">Payment Requests</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            (click)="manageOrders()"
            *ngIf="currentUser == 3 || currentUser == 2"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            routerLink="/manageOrders"
            routerLinkActive="active"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/layout-navbar-expand.svg" /></mat-icon
            ><span class="pop-siz">Manage Orders</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 2"
            routerLink="/playPromoCodes"
            routerLinkActive="active"
            aria-label="Close"
            data-bs-dismiss="offcanvas"
            (click)="playPromoCode()"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/layout-navbar-expand.svg" /></mat-icon
            ><span class="pop-siz">Promo Codes</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 3"
            routerLink="/favouriteOrders_players"
            routerLinkActive="active"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/heart.svg" /></mat-icon
            ><span class="pop-siz">Favorite Orders</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            *ngIf="currentUser == 2"
            routerLinkActive="active"
            routerLink="/favouriteOrders"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/heart.svg" /></mat-icon
            ><span class="pop-siz">Favorite Restaurants</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            (click)="cardDetails()"
            *ngIf="currentUser == 3 || currentUser == 2"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            routerLinkActive="active"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/credit-card.svg" /></mat-icon
            ><span class="pop-siz">Card Details</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            (click)="changesPasswordClick()"
            routerLinkActive="active"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/lock (1).svg" /></mat-icon
            ><span class="pop-siz">Change Password</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            (click)="contactusClick()"
            routerLinkActive="active"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/icon/mail (1).svg" /></mat-icon
            ><span class="pop-siz">Contact Us</span>
          </button>
        </li>

        <li>
          <button
            mat-menu-item
            (click)="logoutClick()"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <mat-icon class="headerMenuIcon"
              ><img
                style=""
                height="24px"
                width="24px"
                src="../../../../assets/landing-page/logout.svg" /></mat-icon
            ><span class="pop-siz">Logout</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
